import { render, staticRenderFns } from "./gc-screen-pdf-view.vue?vue&type=template&id=2ef8e6e9"
import script from "./gc-screen-pdf-view.vue?vue&type=script&lang=js"
export * from "./gc-screen-pdf-view.vue?vue&type=script&lang=js"
import style0 from "./gc-screen-pdf-view.vue?vue&type=style&index=0&id=2ef8e6e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports